import React from 'react';

import { Badge, IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ShoppingCartRounded } from '@material-ui/icons';

import { useCart } from '../hooks/use-cart.hook';

const useStyles = makeStyles((theme) => ({
  iconButton: {
    minWidth: 44,
    minHeight: 44,
  },
  cartBadge: {
    '& .MuiBadge-badge': {
      backgroundColor: theme.palette.client.primary.main,
      color: '#fff',
    },
  },
}));

const CartButton: React.FC = () => {
  const classes = useStyles();
  const { itemCount } = useCart();

  return (
    <IconButton className={classes.iconButton} aria-label="Voir le panier">
      <Badge className={classes.cartBadge} badgeContent={itemCount} showZero={false}>
        <ShoppingCartRounded />
      </Badge>
    </IconButton>
  );
};

export default CartButton;
